import { ForcePDFReader } from "../../files/ForcePDFReader"
import { GenerateFile } from "../../files/GenerateFile"
import { ConvertRectangle } from "../../geometry/ConvertRectangle"
import type { PdfEngine } from "../../types/engine/PdfEngine"
import { ContentType } from "../../types/files/ContentType"
import { VirtualFileType } from "../../types/files/VirtualFileType"
import type { TaskResult } from "../../types/tasks/input/TaskResult"
import type { TaskRasterizeOptions } from "../../types/tasks/options/TaskRasterizeOptions"
import { TaskName } from "../../types/tasks/TaskName"
import { TrackedTaskName } from "../../types/tasks/tracking/TrackedTaskName"
import type { TrackingCallback } from "../../types/tasks/tracking/TrackingCallback"

// options RasterizePdfOptions - file: GeneratedFile
// stream no
// emit TrackingCallback
//
// return DocumentPage[1, GeneratedFile[...]]

export async function* TaskRasterize(
  engine: PdfEngine,
  task: TaskRasterizeOptions,
  emit: TrackingCallback
): AsyncGenerator<TaskResult> {
  const doc = await ForcePDFReader(engine, task.options, task.source, emit)
  const page_count = await doc.page_count()

  try {
    // Update progress if multi-page
    //
    void emit({
      name: TrackedTaskName.RASTERIZE_PDF,
      done: 0,
      total: page_count,
    })

    // Render each page
    for (let page_number = 1; page_number <= page_count; page_number++) {
      const { stream, size } = await doc.rasterize(page_number)

      const content = await GenerateFile(engine, stream, ContentType.PNG)

      yield {
        enum: TaskName.CONTENT_FILE,
        name: `${page_number}.png`,
        content: {
          enum: VirtualFileType.SINGLE_PAGE_IMAGE,
          source: task.source,
          content,
          file_meta: {},
          size: ConvertRectangle(task.options, size),
        },
      }
      void emit({
        name: TrackedTaskName.RASTERIZE_PDF,
        done: page_number,
        total: page_count,
      })
    }
  } finally {
    // Clean up document and release lock
    await doc.close()
  }
}
